import _ from 'lodash';
import moment from 'moment';
import {apiFetch} from '../utility';

const apiBase = 'inventoryAllocation';
const INVENTORY_ALLOCATION_RESULT = 'inventory/inventoryAllocation/search/';

const initialState = {
	byYearMonth : {},
	byYearMonthWarnings : {},
};

export default (state = initialState, action) => {
	if (action.type === INVENTORY_ALLOCATION_RESULT) {
		const { month, year, inventoryAllocations, allocationWarnings} = action;
		const yearMonthMoment = moment().year(year).month(month);
		const yearMonthKey = yearMonthMoment.format('YYYY-MM');
		return {
			...state,
			byYearMonth: {
				...state.byYearMonth,
				[yearMonthKey]: inventoryAllocations
			},
			byYearMonthWarnings: {
				...state.byYearMonthWarnings,
				[yearMonthKey]: allocationWarnings
			}
		};
	} else {
		return state;
	}
};

export const search = (p) => {
	const {
		month,
		year,
		callback = _.noop,
	} = p;

	return dispatch => {
		const params = {month,year};

		apiFetch({
			method: `${apiBase}.search`,
			params,
			dispatch,
			callback : (err, r) => {
				if (err) { return callback(err); }
				const inventoryAllocations = _.get(r, ['collections', 'inventoryAllocationCollection'], []);
				const allocationWarnings = _.get(r, ['warnings'], []);
				dispatch({
					type: INVENTORY_ALLOCATION_RESULT,
					year,
					month,
					inventoryAllocations,
					allocationWarnings,
				});
				callback();
			}
		});
	};
};
